jQuery(document).on("logout", function () {
  if (luvit.getItem("luvit_portalmenustate")) {
    var mycoursesstate = $.parseJSON(
      luvit.getItem("luvit_portalmenustate"),
    ).mycourses;
    luvit.removeItem("luvit_portalmenustate");
    if (mycoursesstate) {
      var state = { mycourses: mycoursesstate };
      luvit.setItem("luvit_portalmenustate", JSON.stringify(state));
    }
  }
  sessionStorage.clear();
});
